import { createAction } from 'redux-act';

export const setSpendingBudgetModalVisible = createAction('SET_SPENDING_BUDGET_MODAL_VISIBLE');
